import React, { useEffect } from 'react';
// import PageHeader from 'components/common/PageHeader';
// import { ProtectedComponent } from './ProtectedComponent.js';

import { fetchQuestCorrente } from 'features-csvc/reduxStore/questCorrenteSlice';
import { useDispatch, useSelector } from 'react-redux';

const Questionario = () => {
  const dispatch = useDispatch();
  const questionarioUuid = useSelector(
    (state) => state.questCorrente.questionarioUuid
  );
//  const aziendaNome = useSelector((state) => state.questCorrente.aziendaNome);

  useEffect( () => {
      dispatch( fetchQuestCorrente (questionarioUuid))
  }, [])


  return (
    <></>
  );
};

export default Questionario;
